(function ($) {
  'use strict';

  $(window).on('hashchange', checkStateSearch);

  if (isStateSearch()) {
    $(document).ready(checkStateSearch);
  }

  function checkStateSearch() {
    if (isStateSearch()) {
      setTimeout(focusSearch, 0);
    }
  }

  function focusSearch() {
    $('.block-sitesearch__container .form-text').focus();
  }

  function isStateSearch() {
    var hash = window.location.hash.replace(/^#/, '');

    return (hash === 'state-search');
  }

})(jQuery);
